import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import styles from './index.module.scss';
import classNames from 'classnames';
import { useDeviceType } from '../../store/device-type';

interface INavigationTab {
  name: string;
  link: string;
  selected?: boolean;
}

interface IProps {
  tabs: INavigationTab[];
}

const NavigationTabs: React.FC<IProps> = (props: IProps) => {
  const { tabs } = props;
  const deviceType = useDeviceType();
  const isMobile = deviceType === 'mobile';
  const mobileScroll = useRef<HTMLUListElement>(null);
  const scroll = (index: number) => {
    if (index === 0) {
      mobileScroll.current.scrollLeft = 0;
    } else if (index > 0) {
      mobileScroll.current.scrollLeft += 100;
    }
  };

  return (
    <nav className={classNames('navigation-tabs', styles['navigation-tabs'])}>
      <ul
        ref={isMobile ? mobileScroll : null}
        className={classNames(
          'navigation-tabs-list',
          styles['navigation-tabs-list'],
        )}
      >
        {tabs.map((tab, index) => {
          return (
            <li
              className={classNames('navigation-tab', styles['navigation-tab'])}
              key={tab.name + index}
              // eslint-disable-next-line react/jsx-no-bind
              onClick={isMobile ? () => scroll(index) : null}
            >
              <Link
                data-testid={'nav-link'}
                to={tab.link}
                className={classNames(
                  'navigation-link',
                  styles['navigation-link'],
                  tab.selected && 'selected',
                  tab.selected && styles.selected,
                )}
              >
                {tab.name}
              </Link>
              {tab.selected && (
                <div
                  data-testid={'selected'}
                  className={classNames(
                    'selected-indicator',
                    styles['selected-indicator'],
                  )}
                ></div>
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default NavigationTabs;
